import { type PayloadAction } from '@reduxjs/toolkit';
import { type WritableDraft } from 'immer';

import { type PriceFieldChangedParams } from '../../types/shared';
import { type QuoteBuilderStateType } from '../../types/state';
import { onQuantityChange } from '../calculations/recalculate';
import { validateDuplicateQuotePriceQuantities } from '../validations/duplicate-quantities';
import { validateQuantity } from '../validations/quantity';

export function quantityChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<PriceFieldChangedParams>,
) {
  const { value, quoteLineUuid, quotePriceUuid } = action.payload;

  const quantity = validateQuantity(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity: value,
  });

  if (!quantity) {
    return;
  }

  onQuantityChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    quantity,
  });

  validateDuplicateQuotePriceQuantities(state, {
    quantity,
    quoteLineUuid,
    quotePriceUuid,
  });
}
